export const BOARD = 'BOARD' as const;
export const BACKLOG = 'BACKLOG' as const;
export const ROADMAPS = 'ROADMAPS' as const;
export const UNKNOWN = 'UNKNOWN' as const;

export type CacheInvalidationType =
	| typeof BOARD
	| typeof BACKLOG
	| typeof ROADMAPS
	| typeof UNKNOWN;

export type ResourcesCacheUpdateRequest = {
	origin: CacheInvalidationType;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	payload: any | null;
};

export const RESOURCES_CACHE_UPDATER_SOURCE = 'RESOURCES_CACHE_UPDATER_SOURCE' as const;

export const RESOURCES_CACHE_UPDATER_SOURCE_KEY = 'resourcesCacheSource';
